<template>
  <kst-section :title="sectionTitle">
    <kst-output field="ProfitLossRptTypeID" :data="details" :catalog="Catalog"/>
    <kst-output field="ReceiveVendorSourceID" :data="details" :catalog="Catalog"/>
    <kst-output field="InvoiceClientSourceID" :data="details" :catalog="Catalog"/>
    <kst-output field="InvoicePrintNote" :data="details" :catalog="Catalog"/>
  </kst-section>
</template>

<script>
import Catalog from "../CpCatalog.js";
import Info from "../CpInfo.js";

export default {
  props: {
    details: Object
  },
  data: () => ({
    Catalog
  }),
  computed: {
    sectionTitle() {
      return Info.Section.Setting.Title;
    }
  }
}
</script>